module.exports = __webpack_public_path__ + "static/media/headset.b66bbe6b.svg";